import React from 'react';
import PropTypes from 'prop-types';

// only way I could think of being able to test this element in relation to modal was adding the testid
const Overlay = ({ className, onClick }) => (
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
  <div className={className} onClick={onClick} data-testid="wds-overlay" />
);

Overlay.propTypes = {
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

Overlay.defaultProps = {
  onClick: undefined,
};

export default Overlay;
